import { AxiosError, AxiosRequestConfig } from 'axios';
import qs from 'qs';

import { DisplayToast } from '@/helpers';

import { MutationResponse } from '@/types/api/mutations';

import axios from '@/axios';

import {
  ResponseErrorData,
  ResponseValidationError,
} from './ResponseValidationError';

function isErrorResponse(data: unknown): data is ResponseErrorData {
  if (!data || typeof data !== 'object') return false;

  const response = data as Record<string, unknown>;

  if (response.flash_type === 'error') return true;

  if (response.status === 'error' && 'errors' in response) return true;

  if (
    'errors' in response &&
    response.errors &&
    response.status !== 'success' &&
    !response.redirect
  ) {
    const errors = response.errors;
    if (Array.isArray(errors) && errors.length > 0) return true;
    if (typeof errors === 'object' && Object.keys(errors).length > 0)
      return true;
  }

  return false;
}

export class HttpClient {
  static async request<Res>(
    requestConfig: AxiosRequestConfig,
  ): Promise<Res | undefined> {
    try {
      const { data } = await axios.request<Res>({
        ...requestConfig,
        paramsSerializer: {
          serialize: (params) => {
            return qs.stringify(params, {
              arrayFormat: 'brackets',
              allowEmptyArrays: true,
            });
          },
        },
      });
      if ((data as unknown as MutationResponse)?.redirect) {
        window.location.href = (data as unknown as MutationResponse).redirect!;
        return data;
      }

      if (isErrorResponse(data)) {
        const errorData = data as unknown as ResponseErrorData;

        if (errorData.flash_type === 'error' && errorData.flash_message) {
          DisplayToast.error(errorData.flash_message);
        } else if (
          Array.isArray(errorData.errors) &&
          errorData.errors.length > 0
        ) {
          const firstError = errorData.errors[0];
          if (typeof firstError === 'string') {
            DisplayToast.error(firstError);
          }
        }

        throw new ResponseValidationError(errorData);
      }

      return data;
    } catch (err) {
      if (ResponseValidationError.isResponseValidationError(err)) {
        throw err;
      }

      const error = err as AxiosError;

      if (error?.response?.status === 401) {
        window.location.href = '/';
      }

      throw err;
    }
  }
}
